// extracted by mini-css-extract-plugin
export default {"textInputLabel":"PM-z","textInput":"QM-z","error":"RM-z","disabled":"SM-z"};